import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export function hitModularHousesTileClick(regionSlug: string | string[]) {
    hitGoogleTagManager({
        event: "modular_house",
        modular_house_action: "tile_click",
        modular_house_region: regionSlug
    });
}
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export function hitModularHousesTileClick(regionSlug: string | string[]) {
    hitGoogleTagManager({
        event: "modular_house",
        modular_house_action: "tile_click",
        modular_house_region: regionSlug
    });
}
